// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2NBBK","description":"PatientConsentPreview_description__321Ki"};